// Hero Slider
const heroSlider = document.querySelectorAll('[data-slider="hero-slider"]');

const heroSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 12,
  watchOverflow: true,
  allowTouchMove: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

heroSlider.forEach((el) => {
  const parentElem = el.closest('.hero-module');

  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');
  const paginationElement = parentElem.querySelector('.swiper-pagination');

  heroSliderOptions.navigation.prevEl = arrowLeft;
  heroSliderOptions.navigation.nextEl = arrowRight;
  heroSliderOptions.pagination.el = paginationElement;

  new Swiper(el, heroSliderOptions);
});
